<div id="applicant_loan_component" [ngClass]="AppComponent.isDesktop ? 'container-xl' : 'container-fluid'" class="{{ApplicantLoanComponent.currentChannel?.channelName}}"
[ngStyle]="{'height': (selectedProducts?.length > 1 && ApplicantLoanComponent.currentStepId !== 2.5) ? 'auto' : ''}" >
  <!-- –– Start Page Container ––-->

  <!--  -->
  <ng-container *ngIf="ApplicantLoanComponent.isCoBrand">
    <app-cobrand-header [steps]="steps" [currentStepId]="ApplicantLoanComponent.currentStepId"></app-cobrand-header>
  </ng-container>

  <ng-container *ngIf="!ApplicantLoanComponent.isCoBrand && ApplicantLoanComponent.currentStepId != 2.1">
    <app-header  [steps]="steps" [currentStepId]="ApplicantLoanComponent.currentStepId"></app-header>
  </ng-container>

  <hr [hidden]="ApplicantLoanComponent.currentStepId == 2.1" style="border-top: 2px solid #E9ECEF;" class="mb-4">

  <div [ngStyle]="{'margin':  AppComponent.isDesktop ? '0 40px 60px 40px' : '0'}">
    <app-step-one [validationErrors]="validationErrors"  *ngIf="ApplicantLoanComponent.currentStepId == 1" 
        [(creditCardLoan)]="creditCardLoan" 
        [(vehicleLoan)]="vehicleLoan"
        (vehicleLoanChange)="vehicleLoanChange($event)"
        [(personalLoan)]="personalLoan"
        (personalLoanChange)="personalLoanChange($event)"
       [(xpressLoan)]="xpressLoan"
       [(eligibilityModel)]="eligibilityModel"
       [(customQuestions)]="customQuestions"
       (productsHaveChanged)="productsHaveChanged($event)"  
       [(selectedProducts)]="selectedProducts"
       (submitHistoryChanged)="submitHistoryChanged($event)"
       ></app-step-one>

    <app-review-page [validationErrors]="validationErrors"  *ngIf="ApplicantLoanComponent.currentStepId == 2" 
      [(creditCardLoan)]="creditCardLoan"
      [(vehicleLoan)]="vehicleLoan"
      [(personalLoan)]="personalLoan" 
      [selectedLoanType]="selectedLoanType"
      [selectedProducts]="selectedProducts"
      [(xpressLoan)]="xpressLoan"    
      [(eligibilityModel)]="eligibilityModel"
      [(customQuestions)]="customQuestions"
      (entityTokenChanged)="handleEntityTokenChange($event)"
      [(submitHistory)]="submitHistory"
      (submitHistoryChanged)="submitHistoryChanged($event)"
      > </app-review-page>

    <app-alloy-verify *ngIf="ApplicantLoanComponent.currentStepId == 2.1" 
      [entityToken]="entity_Token" 
      [journeyApplicationToken]="journeyApplicationToken" 
      (uploadCompleted)="onUploadCompleted($event)"
    ></app-alloy-verify>

    <app-branch-funding-page  *ngIf="ApplicantLoanComponent.currentStepId == 2.5" [selectedProducts]="selectedProducts"
    [(xpressLoan)]="xpressLoan"
    [(creditCardLoan)]="creditCardLoan"
    [(vehicleLoan)]="vehicleLoan"
    [(personalLoan)]="personalLoan"
    [(submitHistory)]="submitHistory"
    ></app-branch-funding-page>

 
    <app-final-page  *ngIf="ApplicantLoanComponent.currentStepId == 3" 
    [selectedProducts]="selectedProducts"
     [(xpressLoan)]="xpressLoan"
     [(submitHistory)]="submitHistory"
     [entityToken]="entity_Token"></app-final-page>
  </div>

  <hr *ngIf="selectedProducts.length > 1" style="border-top: 2px solid #E9ECEF;" class="mt-4">

  <app-footer ></app-footer>
</div>
